import React from "react";
import PropTypes from "prop-types";
import { ZoomIn, ZoomOut, Layers, Maximize } from "lucide-react";

const EventHeatMapControls = ({ t, onZoomIn, onZoomOut, onToggleLayer, onFullscreen }) => (
  <div className="event-heatmap__controls">
    <button type="button" aria-label={t.zoomIn} onClick={onZoomIn}>
      <ZoomIn size={20} />
    </button>
    <button type="button" aria-label={t.zoomOut} onClick={onZoomOut}>
      <ZoomOut size={20} />
    </button>
    <button type="button" aria-label={t.mapLayers} onClick={onToggleLayer}>
      <Layers size={20} />
    </button>
    <button type="button" aria-label={t.fullscreen} onClick={onFullscreen}>
      <Maximize size={20} />
    </button>
  </div>
);

EventHeatMapControls.propTypes = {
  t: PropTypes.object.isRequired,
  onZoomIn: PropTypes.func.isRequired,
  onZoomOut: PropTypes.func.isRequired,
  onToggleLayer: PropTypes.func.isRequired,
  onFullscreen: PropTypes.func.isRequired,
};

export default EventHeatMapControls;
